import { CircularProgress, TextField, TextFieldProps } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { Country } from 'country-region-data'
import React from 'react'

type Props = {
  selectedCountryCode?: string
  onChange?: (country: Country) => Promise<void> | void
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLDivElement>) => void
  TextFieldProps?: TextFieldProps
  disabled?: boolean
}

export const CountrySelector = (props: Props) => {
  const [countryData, setCountryData] = React.useState<Country[]>(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    import('country-region-data/data.json')
      .then((countryData) => {
        setCountryData(countryData.default as Country[])
      })
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return <CircularProgress />
  }

  return (
    <Autocomplete
      options={countryData}
      loading={loading}
      getOptionSelected={(option, value) => {
        if (!value) return true

        return option?.countryShortCode === value?.countryShortCode
      }}
      getOptionLabel={(option) => option?.countryName}
      disabled={loading || props.disabled}
      autoComplete
      autoHighlight
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      autoSelect
      disableClearable
      onChange={(e, value) => {
        if (!value || typeof value === 'string') return
        props.onChange(value)
      }}
      value={
        countryData.find(
          (x) => x.countryShortCode === props.selectedCountryCode
        ) || null
      }
      renderInput={(params) => (
        <TextField
          label={'country'}
          {...props.TextFieldProps}
          {...params}
          inputProps={{
            ...params.inputProps,
            ...props.TextFieldProps.inputProps,
          }}
        />
      )}
    />
  )
}
